import React from 'react';
import '../styles/ProductDetails.css';

const ProductDetails = ({ product, qty, setQty, onAddToInvoice, onQtyEnter }) => {
  if (!product) return null;

  return (
    <div className="product-details">
      <div className="product-header">
        <h3 className="product-name">{product.name}</h3>
        <span className="product-badge">{product.type}</span>
      </div>

      <div className="product-info">
        <div className="info-item">
          <span className="info-label">Stock Available:</span>
          <span className="info-value stock-qty">{product.stockQty} units</span>
        </div>
        <div className="info-item">
          <span className="info-label">Unit Price:</span>
          <span className="info-value price">
            {product.type === 'fixed' ? product.price : product.pricePerKg} LKR
          </span>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="qty" className="form-label">Quantity</label>
        <div className="quantity-controls">
          <input
            id="qty"
            type="number"
            value={qty}
            onChange={(e) => setQty(Number(e.target.value))}
            min="1"
            onKeyDown={(e) => {
              if (e.key === 'Enter') onQtyEnter();
            }}
            className="form-input qty-input"
          />
          <button onClick={onAddToInvoice} className="btn btn-success">
            <span className="btn-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z" clipRule="evenodd" />
              </svg>
            </span>
            Add to Invoice
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;